{
  "INTEGRATION_APPS": {
    "FETCHING": "Načítavajú sa integrácie",
    "NO_HOOK_CONFIGURED": "Pre tento účet nie sú nakonfigurované žiadne integrácie {integrationId}.",
    "HEADER": "Aplikácie",
    "STATUS": {
      "ENABLED": "Zapnuté",
      "DISABLED": "Vypnuté"
    },
    "CONFIGURE": "Konfigurovať",
    "ADD_BUTTON": "Pridať nový hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Potvrdiť odstránenie",
        "ACCOUNT": "Odpojiť"
      },
      "MESSAGE": {
        "INBOX": "Naozaj chcete odstrániť?",
        "ACCOUNT": "Naozaj chcete odpojiť?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Áno, odstrániť",
        "ACCOUNT": "Áno, odpojiť"
      },
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "API": {
        "SUCCESS_MESSAGE": "Hook bol úspešne odstránený",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
      }
    },
    "LIST": {
      "FETCHING": "Načítavajú sa integračné hooky",
      "INBOX": "Schránka",
      "DELETE": {
        "BUTTON_TEXT": "Vymazať"
      },
      "EDIT": {
        "BUTTON_TEXT": "Upraviť"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Vyberte schránku",
          "PLACEHOLDER": "Vyberte schránku"
        },
        "SUBMIT": "Vytvoriť",
        "CANCEL": "Zrušiť"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integračný hook bol úspešne pridaný",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru Woot, skúste to prosím neskôr"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Pripojiť"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Odpojiť"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Načítajte dáta z vlastného servera a zobrazte ich v bočnom paneli konverzácie. Vracia HTML (zobrazené v iframe) alebo JSON (zobrazený ako zoznam kľúč/hodnota).",
      "DIALOGFLOW": "Dialogflow je platforma spracovania prirodzeného jazyka na vytváranie konverzačných rozhraní. Integrácia s {installationName} umožňuje botom najprv spracovať dopyty a preposlať ich agentom, keď je to potrebné. Pomáha kvalifikovať potenciálnych zákazníkov a znížiť pracovné zaťaženie agentov odpovedaním na časté otázky. Ak chcete pridať Dialogflow, vytvorte servisný účet v Google Console a zdieľajte prihlasovacie údaje. Podrobnosti nájdete v dokumentácii.",
      "DAKTELA": "Synchronizujte e-maily a webchaty s vaším účtom Daktela.",
      "RETINO": "Retino zavedie poriadok do správy vrátení a reklamácií.",
      "MAILSHIP": "Mailship je systém správy skladu a vybavovania objednávok. Vyhľadajte stav objednávky, sledovanie a údaje o expedícii.",
      "RAYNET": "Pripojte svoj účet Raynet CRM a získajte prístup k údajom o zákazníkoch. Pridajte pripojenie pomocou používateľského mena a API tokenu Raynet."
    },
    "EDIT": {
      "TITLE": "Upraviť {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Vyberte schránku",
          "PLACEHOLDER": "Vyberte schránku"
        },
        "SUBMIT": "Aktualizovať",
        "CANCEL": "Zrušiť"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integračný hook bol úspešne aktualizovaný",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chat serveru. Skúste to prosím neskôr."
      }
    },
    "TEST_CONNECTION": {
      "BUTTON": "Otestovať pripojenie",
      "SUCCESS": "Pripojenie úspešné",
      "ERROR": "Pripojenie zlyhalo. Skontrolujte svoje prihlasovacie údaje."
    }
  }
}
